module.exports = __webpack_public_path__ + "assets/img/Exchange_btn.e8a57525.png";